module.exports = __webpack_public_path__ + "logo.png?4b041bd75e091efb18251e2bcfafed45";